module.exports = __webpack_public_path__ + "img/email_read.09a6c0bf.svg";